/**
 * Implements a page navigation bar
 */
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { enums } from '@kattana-io/common';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import ConnectedWallet from '../../components/ConnectedWallet';
import ChartPicker from '../../components/Picker';
import NavigationLinks from '../../components/NavigationLinks';
import Premium from '../../components/Premium';
import News from '../../components/News';
import NetworkSelector from '../../components/NetworkSelector';
import { IStore } from '../../reducers';
import { actionOpenTickers } from '../../actions/modal';
import logo from '../../assets/images/kattana_logo.svg';
import AppTitle from './AppTitle';
import './styles.scss';

const premiumLogoStyles = {
  backgroundColor: '#f20d33',
  borderRadius: 4,
};

interface IHeaderProps {
  chartPicker?: boolean;
}

const Header = ({ chartPicker = true }: IHeaderProps) => {
  const id = useSelector((state: IStore) => state.current.id);
  const plan = useSelector((state: IStore) => state.features.currentPlan);

  const logoRef = useRef<HTMLAnchorElement>(null);
  const dispatch = useDispatch();

  /**
   * Call logo shimmer animation
   */
  useEffect(() => {
    let timer: number;

    window.requestAnimationFrame(() => {
      if (logoRef.current) {
        logoRef.current.classList.add('logo--updating');
      }

      timer = window.setTimeout(() => {
        if (logoRef.current) {
          logoRef.current.classList.remove('logo--updating');
        }
      }, 1500);
    });

    return () => window.clearTimeout(timer);
  }, [id]);

  return (
    <div className='header'>
      <AppTitle />
      <div className='header__left_block'>
        <Link
          to='/'
          className='logo header__cnt'
          ref={logoRef}
          style={
            plan === enums.PricingPlan.premium ? premiumLogoStyles : undefined
          }
        >
          <Image size='m' src={logo} />
        </Link>
        {chartPicker && <ChartPicker />}
        <div
          className='find'
          onClick={() => dispatch(actionOpenTickers({ center: false }))}
        >
          <div className='icon-search' />
          <Text className='find__text' size={14} data-qa='search-btn'>
            Search Market, Ticker or Token Address...
          </Text>
        </div>
      </div>
      <div className='header__right_block'>
        <div className='header__right_block__actions_box'>
          <NavigationLinks />
          <Premium />
          <Link to='/help' className='news__icon icon-tooltip-circle' />
          <News />
        </div>
        <div className='header__right_block__wallet_box'>
          <NetworkSelector imageSize='l' textWeight='400' />
          <ConnectedWallet />
        </div>
      </div>
    </div>
  );
};

export default Header;
